module.exports = "/_next/static/images/Danger-4ba57d83f23a870d7ab68cb6a8d93c20.svg";